import { render, staticRenderFns } from "./TraxUiInput.vue?vue&type=template&id=38d44fa5&scoped=true"
import script from "./TraxUiInput.vue?vue&type=script&lang=js"
export * from "./TraxUiInput.vue?vue&type=script&lang=js"
import style0 from "./TraxUiInput.vue?vue&type=style&index=0&id=38d44fa5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d44fa5",
  null
  
)

export default component.exports